import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import HelpZone from "./pages/HelpZone";
import Reports from "./pages/Reports";
import Essentials from "./pages/Essentials";
import Support from "./pages/Support";
import Form from "./pages/Form";
import Form2 from "./pages/Form2";
import Account from "./pages/Account";
import Issues from "./pages/Issues";

const theme = createTheme({
  typography: {
    fontFamily: "MuseoSans, sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 500,
    fontWeightMedium: 700,
    fontWeightBold: 900,
    h1: {
      fontWeight: 900,
      lineHeight: 1.2,
      letterSpacing: "-0.015em",
      fontSize: "2.25rem",
      marginBottom: "1.5rem",
      "@media (min-width:600px)": {
        fontSize: "3rem",
      },
      "@media (min-width:900px)": {
        fontSize: "3.75rem",
      },
    },
    h2: {
      fontWeight: 900,
      lineHeight: 1.3,
      fontSize: "1.875rem",
      marginBottom: "1.25rem",
      "@media (min-width:600px)": {
        fontSize: "2.25rem",
      },
      "@media (min-width:900px)": {
        fontSize: "3rem",
      },
    },
    h3: {
      fontWeight: 700,
      lineHeight: 1.3,
      fontSize: "1.5rem",
      marginBottom: "1rem",
      "@media (min-width:600px)": {
        fontSize: "1.875rem",
      },
    },
    h4: {
      fontWeight: 700,
      lineHeight: 1.4,
      fontSize: "1.25rem",
      marginBottom: "1rem",
      "@media (min-width:600px)": {
        fontSize: "1.5rem",
      },
    },
    h5: {
      fontWeight: 500,
      lineHeight: 1.5,
      fontSize: "1.125rem",
      marginBottom: "0.75rem",
    },
    h6: {
      fontWeight: 500,
      lineHeight: 1.6,
      fontSize: "1rem",
      marginBottom: "0.5rem",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 300,
      lineHeight: 1.6,
      marginBottom: "1rem",
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 300,
      lineHeight: 1.5,
      marginBottom: "0.75rem",
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="strefa" element={<HelpZone />} />
            <Route path="formularze" element={<Reports />} />
            <Route path="niezbednik" element={<Essentials />} />
            <Route path="pomoc" element={<Support />} />
            <Route path="formularze/przemoc" element={<Form />} />
            <Route path="formularze/mobbing" element={<Form2 />} />
            <Route path="konto" element={<Account />} />
            <Route path="lista" element={<Issues />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
